<template>
  <el-dialog
    title="选择企业及产品"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    @closed="handleClosed">
    <el-steps
      align-center
      :active="active"
      finish-status="success">
      <el-step title="选择企业"></el-step>
      <el-step title="选择产品"></el-step>
    </el-steps>
    <vendor-select-table
      v-show="active === 0"
      ref="vendor" />
    <product-select-table
      v-show="active === 1"
      ref="product" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        v-if="active === 1"
        type="primary"
        @click="prev">上一步</el-button>
      <el-button
        v-if="active === 0"
        type="primary"
        @click="next">下一步</el-button>
      <el-button
        v-if="active === 1"
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ProductSelectTable from './product-select-table.vue'
import VendorSelectTable from './vendor-select-table.vue'

export default {
  name: 'VendorSelectModal',
  components: { ProductSelectTable, VendorSelectTable },
  props: {
    callback: Function,
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      active: 0,
      currenVendor: {},
      currenProduct: {}
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() { },
    next() {
      const currenVendor = this.$refs.vendor.current
      if (!currenVendor.vendorId) {
        this.$message.error('请选择一家企业')
        return
      }
      this.$set(this, 'currenVendor', currenVendor)
      this.active = this.active + 1
      this.$refs.product.fetch({
        vendorId: currenVendor.vendorId,
        vendorName: currenVendor.vendorName
      })
    },
    prev() {
      this.active = this.active - 1
      this.$refs.product.reset()
    },
    add() {
      const currenProduct = this.$refs.product.current
      if (!currenProduct.productId) {
        this.$message.error('请选择一个产品')
        return
      }
      this.callback && this.callback(this.currenVendor, currenProduct)
      if (this.autoClose) {
        this.toggleModal(false)
      }
    },
    fetch() {
      this.toggleModal(true)
      this.$nextTick(() => {
        this.$refs.vendor.fetchList()
      })
    }
  }
}
</script>
